import { FolderFilledIcon } from '@/components/Icons';
import { ScrollArea } from '@/components/ui/scroll-area';
import { FolderItemType } from '@/service/type/Folder';
import useFolderStore from '@/state/folder-store';
import { useAddNewFolderShow } from '@/state/show-store';
import { cn } from '@/utils';
import React, { useState } from 'react';

interface FolderSelectorProps {
  onchange: (id: number, folderDetail: FolderItemType & { fatherFolder: FolderItemType | null }) => void;
  className?: string;
  onCreateFolder?: () => void;
}

export const FolderSelector = ({ onchange, className, onCreateFolder }: FolderSelectorProps) => {
  const { folderState } = useFolderStore();
  const { setIsShow: setIsShowCreateNewFolder } = useAddNewFolderShow();
  return (
    <FolderSelectorUI
      setIsShowCreateNewFolder={setIsShowCreateNewFolder}
      onCreateFolder={onCreateFolder}
      className={className}
      folderState={folderState}
      onchange={onchange}
    />
  );
};

interface FolderSelectorUIProps {
  folderState: FolderItemType[];
  onchange: (id: number, folderDetail: FolderItemType & { fatherFolder: FolderItemType | null }) => void;
  className?: string;
  onCreateFolder?: () => void;
  setIsShowCreateNewFolder?: (val: boolean) => void;
}

export const FolderSelectorUI: React.FC<FolderSelectorUIProps> = ({
  setIsShowCreateNewFolder,
  folderState,
  onchange,
  className,
  onCreateFolder,
}) => {
  const [selectedFolderId, setSelectedFolderId] = useState<number | null>(null);

  const handleSelectFolder = (folder: FolderItemType, fatherFolder: FolderItemType | null) => {
    setSelectedFolderId(folder.id);
    onchange(folder.id, { ...folder, fatherFolder: fatherFolder! });
  };

  return (
    <div className={cn(className, 'py-jen-spacing-8 px-jen-spacing-16 pl-0 h-[280px] overflow-hidden')}>
      <ScrollArea className="h-full">
        {folderState?.length ? (
          folderState.map((folder) => (
            <Folder
              key={folder.id}
              folder={folder}
              selectedFolderId={selectedFolderId}
              onSelectFolder={handleSelectFolder}
              fatherFolder={null}
            />
          ))
        ) : (
          <div
            className="flex h-full text-jen-content-tertiary justify-center items-center"
            onClick={() => {
              onCreateFolder?.();
              setIsShowCreateNewFolder?.(true);
            }}
          >
            <div
              // onClick={handleGoBack}
              className="  w-fit mx-auto mt-[12px] flex justify-center items-center gap-[10px] text-jen-orange hover:underline cursor-pointer"
            >
              <div className=" w-[28px] h-[28px] flex justify-center items-center rounded-full ">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" className=" text-jen-black">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM20.4012 13.9998L13.8248 7.29932L12.3974 8.70026L16.6173 12.9998H9V14.9998H16.6173L12.3974 19.2993L13.8248 20.7003L20.4012 13.9998Z"
                    fill="#FF5B27"
                  ></path>
                </svg>
              </div>
              Create a new folder{' '}
            </div>
          </div>
        )}
      </ScrollArea>
    </div>
  );
};

interface FolderProps {
  folder: FolderItemType;
  selectedFolderId: number | null;
  onSelectFolder: (folder: FolderItemType, fatherFolder: FolderItemType | null) => void;
  fatherFolder: FolderItemType | null;
}

const Folder: React.FC<FolderProps> = ({ folder, selectedFolderId, onSelectFolder, fatherFolder }) => {
  const isSelected = folder.id === selectedFolderId;

  return (
    <div className="ml-4 text-jen-interactive-secondary ">
      {/* Folder Item */}
      <div
        className={cn(`flex items-center p-2 cursor-pointer rounded-lg border border-transparent hover:bg-[#ffded4] transition-colors`, {
          'bg-[#ffded4] border border-[#ff8f6c] text-jen-active-primary': isSelected,
        })}
        onClick={() => onSelectFolder(folder, fatherFolder)}
      >
        <FolderFilledIcon className="mr-[4px]" />
        {folder.name} ({folder.count})
      </div>

      {/* Child Folders */}
      {folder?.child_folder?.length > 0 && (
        <div className="">
          {folder?.child_folder?.map((child) => (
            <Folder
              key={child.id}
              folder={child}
              selectedFolderId={selectedFolderId}
              onSelectFolder={onSelectFolder}
              fatherFolder={folder}
            />
          ))}
        </div>
      )}
    </div>
  );
};
